import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
import axios from "axios";

export default function ProductsDetails() {
    const { t, i18n } = useTranslation();
    const { id } = useParams();
    const productId = parseInt(id);
    useScrollAnimation();

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    "https://laravel-api.alnujoud-jo.com/api/products"
                );

                setData(response.data.data);

            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, []);

    if (isLoading) {
        return <div className="text-center">Loading...</div>;
    }

    const prod = data.find((item) => item.id === productId);

    if (!prod) {
        return (
            <div className="text-center text-red-500">
                {t("Product Not Found")}
            </div>
        );
    }

    const getLocalizedText = (key) => {
        return i18n.language === 'ar' ? key.A : key.E;
    };

    return (
        <>
            <section className="landingpages">
                <div className="container h-full flex flex-col items-center justify-center text-center">
                    <div className="btmAni1256 text-[#017E89] font-bold text-[35px] capitalize">
                        {t("Products Details")}
                    </div>
                    <div className="btmAni2000 flex items-center gap-[5px] font-bold">
                        <Link to={"/"}>{t("Home")}</Link> -
                        <span className="text-[#017E89] capitalize">
                            {t("Products Details")}
                        </span>
                    </div>
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[50px]">

                    <div className="flex items-baseline gap-[7px]">
                        <img
                            className="w-[35px] h-auto"
                            src={require("../../assets/icons/lineTitle.svg").default}
                            alt=""
                        />
                        <div className="flex flex-col gap-[4px]">
                            <div className="font-bold capitalize text-[25px] text-[#017e89]">
                                {getLocalizedText({ A: prod.name_ar, E: prod.name_en })}
                            </div>
                            <div className="flex items-center gap-[8px] text-[18px] capitalize">
                                {getLocalizedText({ A: prod.category?.name_A || "", E: prod.category?.name_E || ""})}
                                -
                                {getLocalizedText({ A: prod.sub_category?.name_A || "", E: prod.sub_category?.name_E || ""})}
                            </div>
                        </div>
                    </div>

                    <div className="f-col flex gap-[30px]">
                        <div className="w-100 w-[49%] h-fit border-[1px] border-[#017e8926]">
                            <img
                                className="w-[100%] h-[100%] object-cover rounded-[4px]"
                                src={prod.image}
                                alt={prod.name_en}
                            />
                        </div>

                        <div className="w-100 w-[49%] flex flex-col gap-[10px]">
                            <div className="font-bold text-[22px] my-[3px] capitalize">
                                {t("About Product")}
                            </div>
                            <p className="whitespace-pre-line leading-relaxed">
                                {getLocalizedText({ A: prod.details_ar, E: prod.details_en })
                                    ?.replace(/\. /g, ".\n\n")
                                    .replace(/، /g, "،\n")
                                    .replace(/: /g, ":\n")
                                }
                            </p>
                        </div>
                    </div>

                    <div className="flex flex-col items-center justify-center gap-[15px]">
                        {prod.result_img && prod.result_img.length > 0 && (
                            <>
                                <div className="font-bold text-[22px] my-[3px] capitalize">
                                    {t("Results images")}
                                </div>
                                <div className="flex flex-col gap-[10px] w-full">
                                    {prod.result_img.map((img, index) => (
                                        <div key={index} className="w-full h-[350px] border-[1px] border-[#017e8926]">
                                            <img
                                                className="w-full h-full object-contain rounded-[4px]"
                                                src={img}
                                                alt={`${prod.name_en} - ${index + 1}`}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>


                </div>
            </section>
        </>
    );
}